import { packNetAxios } from "@/lib/api-client";
import { type X5Machine } from "@/schemas";
import { baseRoutes } from "@/api/base-routes";

const x5Api = `${baseRoutes.x5}/api/v1/machines`;

export async function getX5Machines(): Promise<X5Machine[]> {
	const response = await packNetAxios.get<X5Machine[]>(x5Api);
	return response.data.map((machine) => ({ ...machine, machineType: "X5" as const }));
	// return z.array(x5MachineSchema).parse(response.data); // TODO: Test parse
}

export async function deleteX5Machine(machineId: string): Promise<void> {
	await packNetAxios.delete(`${x5Api}/${machineId}`);
}

export async function getVersion(): Promise<string> {
	const response = await packNetAxios.get<string>(`${baseRoutes.x5}/api/version`);
	return response.data;
}
